function parsearCombinacao(valor) {
  if (typeof valor !== "string") return valor ?? null;
  try { return JSON.parse(valor); } catch (_) { return null; }
}

// O saldo muda a cada venda; a identidade da variação depende dos atributos.
function chaveVariacao(valor) {
  const item = parsearCombinacao(valor);
  if (!item || typeof item !== "object") return null;
  const ordenar = (obj) => {
    if (Array.isArray(obj)) return obj.map(ordenar);
    if (!obj || typeof obj !== "object") return obj;
    return Object.keys(obj).sort().reduce((resultado, chave) => {
      resultado[chave] = ordenar(obj[chave]);
      return resultado;
    }, {});
  };
  const atributos = { ...item };
  delete atributos.quantidade;
  delete atributos.quantidade_original;
  delete atributos.quantidade_original_combinacao;
  return Object.keys(atributos).length ? JSON.stringify(ordenar(atributos)) : null;
}

function combinacaoParaVenda(valor, quantidade = 0) {
  const item = parsearCombinacao(valor);
  if (!item || typeof item !== "object" || Array.isArray(item)) return null;
  const resultado = {};
  for (const [chave, atributo] of Object.entries(item)) {
    if (["quantidade", "quantidade_original", "quantidade_original_combinacao"].includes(chave)) continue;
    resultado[chave] = atributo && typeof atributo === "object"
      ? atributo.nome ?? atributo.name ?? atributo.valor ?? atributo.value ?? atributo
      : atributo;
  }
  return Object.keys(resultado).length ? { ...resultado, quantidade: Number(quantidade) } : null;
}

function listarOpcoesCombinacao(combinacoes = []) {
  const opcoes = new Map();
  const registros = [...combinacoes].sort((a, b) => {
    const dataA = Date.parse(a.updated_at_servidor || a.updated_at || "") || 0;
    const dataB = Date.parse(b.updated_at_servidor || b.updated_at || "") || 0;
    return dataA - dataB || Number(a.id_produto_combinacao) - Number(b.id_produto_combinacao);
  });

  for (const comb of registros) {
    const parsed = parsearCombinacao(comb.combinacao_json ?? comb.combinacao);
    const itens = Array.isArray(parsed) ? parsed : [parsed];
    itens.forEach((item, indice) => {
      const chave = chaveVariacao(item) || `registro:${comb.id_produto_combinacao}:${indice}`;
      const atributos = item && typeof item === "object"
        ? Object.keys(item).filter(k => !["quantidade", "quantidade_original", "quantidade_original_combinacao"].includes(k))
        : [];
      const descricao = atributos.map(k => {
        const valor = item[k];
        return `${k}: ${valor && typeof valor === "object" ? valor.nome ?? valor.name ?? JSON.stringify(valor) : valor}`;
      }).join(" | ");
      const saldo = item?.quantidade;
      opcoes.set(chave, {
        chave,
        descricao: descricao || comb.descricao_combinacao || "—",
        quantidadeEstoque: saldo != null && Number.isFinite(Number(saldo)) ? Number(saldo) : null,
        combinacaoOriginal: comb,
        itemVariacao: item,
      });
    });
  }
  return [...opcoes.values()];
}

module.exports = { parsearCombinacao, chaveVariacao, combinacaoParaVenda, listarOpcoesCombinacao };
